import React, {Component} from 'react';
import TableHeaderColumn from './TableHeaderColumn';
import PropTypes from 'prop-types';
import TableComponentEnum from './../../utils/TableComponentEnum';

class TableRowColumn extends Component {
  static componentType = TableComponentEnum.TABLEHEAD;

  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
  };

  onClick = (event) => {
  //  if (this.props.onClick) {
  //    this.props.onClick(event, this.props.columnNumber);
  //  }
  };

  render() {
    const {
      children,
      className,
      onClick, // eslint-disable-line no-unused-vars
    } = this.props;

    const handlers = {
      onClick: this.onClick,
    };

    return (
      <thead
        className={className}
        {...handlers}
      >

      {(this.props.type !== undefined) ?
          <tr>
              {this.props.tableHeaderColumnList.map(item => {
                  return (
                      <TableHeaderColumn key={item.key}>
                          {item.columnName}
                      </TableHeaderColumn>
                  );
              })}
          </tr>: ''
      }
        {children}
      </thead>
    );
  }
}

export default TableRowColumn;
